<template>
  <div>
    <base-modal
      :showing="visible"
      size="max-w-5xl"
      @opened="onOpened"
      @close="$emit('close')"
    >
      <div class="space-y-6">
        <div class="flex items-center justify-between">
          <div class="flex items-center space-x-4">
            <div>
              <h3 class="text-lg font-bold leading-6 text-gray-900">
                Daftar kelompok
              </h3>
              <p class="mt-1 max-w-2xl text-sm text-gray-500">
                Daftar kelompok Yang Telah Dibuat
              </p>
            </div>
          </div>
        </div>
        <div class="space-y-4 border-t border-gray-200 pt-6">
          <div class="flex justify-end gap-x-2">
            <base-input
              placeholder="Cari Kode atau Nama"
              type="search"
              :shadow="false"
              debounce
              v-model="filter.search"
              @native-input="loadProductCategories"
            />
          </div>
          <datatable
            :columns="tableColumns"
            :total="productCategories.meta.page.total"
            :perPage="productCategories.meta.page.perPage"
            :currentPage="productCategories.meta.page.currentPage"
            :meta="productCategories.meta"
            @pagechanged="onPagechanged"
          >
            <template v-slot:tbody="{ classes }">
              <tr
                v-for="office in productCategories.data"
                :key="office.id"
                :class="[classes.tr, 'cursor-pointer hover:bg-green-100']"
                @click="onClickRow(office)"
              >
                <td :class="[classes.td]">
                  {{ office.attributes.code }}
                </td>
                <td :class="[classes.td]">
                  {{ office.attributes.name }}
                </td>
              </tr>
            </template>
          </datatable>
        </div>
      </div>
    </base-modal>
    <loading v-if="loading" />
  </div>
</template>

<script>
import BaseModal from '@/components/base/BaseModal';
import { requestMixin } from '@/mixins/request/request';
import { mapGetters } from 'vuex';

export default {
  components: {
    BaseModal,
  },
  mixins: [requestMixin],
  props: {
    visible: Boolean,
  },
  emits: ['close', 'click-row'],
  data() {
    return {
      productCategories: {
        data: [],
        meta: {
          page: {},
        },
      },
      loading: false,
      filter: {
        search: null,
      },
    };
  },
  computed: {
    ...mapGetters({
      me: 'auth/getUser',
    }),
    tableColumns() {
      return [
        {
          id: 'code',
          name: `Kode`,
        },
        {
          id: 'name',
          name: `Nama`,
        },
      ];
    },
  },
  methods: {
    async loadProductCategories(params) {
      this.loading = true;

      const [res, error] = await this.request(`/api/v1/product-categories`, {
        params: {
          'page[size]': 5,
          ...params,
        },
      });

      if (!error) {
        this.productCategories = res;
      }

      this.loading = false;
    },
    onClickRow(office) {
      this.$emit('click-row', office, this.productCategories);
    },
    onOpened() {
      this.filter.search = null;

      this.loadProductCategories();
    },
    onPagechanged(page) {
      this.loadProductCategories({
        'page[number]': page,
      });
    },
  },
};
</script>
